import { getExtensions } from '@atlassian/relay-capture-extensions';
import {
	extractTraceInfoFromResponse,
	type NetworkTraceInfo,
} from '@atlassian/search-client/network-trace-info';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import SearchResultsCqlQuery from '../../../ui/search-page-relay/search-results/__generated__/searchResultsCqlQuery.graphql';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import SearchResultsQuery from '../../../ui/search-page-relay/search-results/__generated__/searchResultsQuery.graphql';

import { getQueryUpdatedTime } from './query-updated-time';

export type ExtensionData = {
	traceId: string | undefined;
	queryUpdatedAgo: number | undefined;
};

/**
 * Extracts the gateway object from the latest captured Relay extensions
 * for the given query type.
 */
const getLatestGateway = (isCQL: boolean): Record<string, any> | undefined => {
	const extensions = getExtensions(
		isCQL ? SearchResultsCqlQuery.operation.name : SearchResultsQuery.operation.name,
	)?.at(-1) as Record<string, any> | undefined;
	return extensions?.gateway;
};

export function getExtensionData(isCQL: boolean): ExtensionData {
	const gateway = getLatestGateway(isCQL);
	const traceId = gateway?.['trace_id'];
	const queryUpdatedAgo = getQueryUpdatedTime();
	return { traceId, queryUpdatedAgo };
}

/**
 * Extracts NetworkTraceInfo (request_id, trace_id) from the latest captured
 * Relay extensions for the given query type.
 */
export function getRelayNetworkTraceInfo(isCQL: boolean): NetworkTraceInfo | undefined {
	const gateway = getLatestGateway(isCQL);
	if (!gateway) {
		return undefined;
	}

	return extractTraceInfoFromResponse({ extensions: { gateway } });
}
